export default __webpack_public_path__ + "static/media/percentage.30553694.svg";